import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { ToastWithTwoButtons } from '../../../../../../component/toasts/toast-with-two-buttons';
import globalSettingsBranches from '../../../../../../stores/global-settings-branches';
import globalSettingsStores from '../../../../../../stores/settings-stores';

const updateWorkingYears = async (
  requestWorkingYear: number,
  workingYearAvailable: number[],
) => {
  await appApi.updateWorkingYears(requestWorkingYear!, workingYearAvailable);
  globalSettingsStores.fetchSetting();

  /*globalSettingsBranches.workingTimeManagement = {
    id: 1,
    currentWorkingYear: requestWorkingYear,
    availableWorkingYears: workingYearAvailable,
    createdAt: new Date(),
    createdBy: 1,
    createdByName: '',
  };*/
  /*
  globalSettingsBranches.workingTimeManagement.currentWorkingYear =
    requestWorkingYear;
  globalSettingsBranches.workingTimeManagement.availableWorkingYears =
    workingYearAvailable;*/

  toast.success('הפעולה בוצעה בהצלחה');
};

export const updateWorkingYearsOperation = async (
  currentWorkingYear: number | undefined,
  requestWorkingYear: number | null,
  workingYearAvailable: number[],
) => {
  try {
    if (requestWorkingYear === null) {
      toast.warn('יש לבחור שנת עבודה נוכחית');
      return;
    }
    if (
      currentWorkingYear !== undefined &&
      currentWorkingYear > requestWorkingYear
    ) {
      ToastWithTwoButtons(
        'שים לב! אתה עומד להעביר את הפעילות לשנה קודמת, ולא לשנה עתידית. האם אתה בטוח שברצונך להמשיך?',
        async () =>
          await updateWorkingYears(requestWorkingYear, workingYearAvailable),
        () => {
          // Do nothing
        },
      );
    } else {
      await updateWorkingYears(requestWorkingYear, workingYearAvailable);
    }
  } catch (e) {
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `updateWorkingYearsOperation is failed with the currentWorkingYear: ${currentWorkingYear}, requestWorkingYear: ${requestWorkingYear}, workingYearAvailable: ${workingYearAvailable} and the error: ${e}`,
    );
  }
};
